// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4568":"16ee66bb","8491":"8864e86b","8741":"a1d388d5"}[chunkId] + ".chunk.css";
};